import { Component, OnInit,Input, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import {TranslateService} from 'ng2-translate';
import { ProjectsService } from '../services/projects.service';
import { AlertManagerService } from '../../../shared/services/alert-manager.service';
import { InlineEditorService } from '../../../shared/services/inline-editor.service';

import { Sprint, Story } from '../../models';

declare var $:any; 

@Component({
  selector: 'app-modal-module',
  templateUrl: './modal-module.component.html',
})
export class ModalModuleComponent implements OnInit {

  @Input() projectId: number;
  @ViewChild('moduleModal') moduleModal: ElementRef;
  moduleForm : FormGroup;

  module: any = {};
  modules: Array<any> = [];
  moduleId: number;
  isSubmitted: boolean =  false;
  isCreate: boolean = true;

  isDeleteConfirm: Array<boolean> = [];
  trasparent: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private projectsService: ProjectsService,
    private alertService: AlertManagerService,
    private translate: TranslateService,
    private inlineEditorService: InlineEditorService) { }

  ngOnInit() {
    this.initModuleForm();
  }

  initModuleForm(){
    this.moduleForm = this.formBuilder.group({
        title: ['', Validators.required],
        description: [ ]
    });
  }

  openModuleModal(){
    this.isCreate = true;
    this.getModules(true);
  }

  openDeleteConfirmFrom(time){
    this.trasparent = true;
    this.isDeleteConfirm[time.id] = true;
  }

  doConfirmeDelete(event, time){
    if(event){
      this.deleteModule(time);
    }
    this.trasparent = false;
    this.isDeleteConfirm[time.id] = false;
  }

  resetForm(){
    this.moduleForm.reset();
    this.isSubmitted = false;
  }

  doCreateModule(){
    this.isSubmitted = true;
    if(this.moduleForm.valid){
      if(this.isCreate){
        this.createModule();
      }else{
        // this.editModule();
      }
    }  
  }

  createModule(){
    this.projectsService.createModule(this.projectId, this.module).subscribe(
      res => {
        this.alertService.success({title: "SUCCESS", msg: "Successfully Created"});
        this.getModules(false);
        this.resetForm();
      }
    );
  }

  editModule(event, object: any, isTitle: boolean){
    let moduleObj = {};
    moduleObj['title'] = isTitle ? event.value : object.title;
    moduleObj['description'] = !isTitle ? event.value : object.description;
    this.projectsService.editModule(this.projectId, object.id, moduleObj).subscribe(
      res => {
        this.inlineEditorService.setValue(event);
        this.alertService.success({title: "SUCCESS", msg: "Successfully Created"});
        this.getModules(false);
      },
      error=>{
        event.value = isTitle ? object.title : object.description;
        this.inlineEditorService.setValue(event);
      }
    );
  }

  deleteModule(module: any){
    this.projectsService.deleteModule(this.projectId, module.id).subscribe(
      res => {
        this.alertService.success({title: "SUCCESS", msg: "Successfully Deleted"});
        this.getModules(false);
      }
    );
  }

  getModules(isOpen: boolean){
    this.projectsService.getModules(this.projectId).subscribe(
      module => {
         this.modules = module.data; 
         if(isOpen){
            $(this.moduleModal.nativeElement).modal({backdrop: 'static', keyboard: false}) 
            $(this.moduleModal.nativeElement).modal('show');
         }
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/work/modal/modal-module.component.ts